import { render, staticRenderFns } from "./SwitchEditor.vue?vue&type=template&id=567eefe5&"
import script from "./SwitchEditor.vue?vue&type=script&lang=js&"
export * from "./SwitchEditor.vue?vue&type=script&lang=js&"
import style0 from "./SwitchEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports